const STORAGE_KEY = 'shipsops.rc5.view-state.v1';
export class ViewStateStore {
  constructor(storage = globalThis.sessionStorage) { this.storage = storage; this.state = this.read(); }
  key(route) { return `${route.page}:${route.section || ''}`; }
  capture(route, root) {
    if (!root) return;
    const active = root.ownerDocument?.activeElement;
    const focusKey = active?.closest?.('[data-focus-key]')?.dataset?.focusKey || active?.getAttribute?.('name') || '';
    this.state[this.key(route)] = { scrollTop: Number(root.scrollTop || 0), focusKey: String(focusKey || '').slice(0, 100), at: Date.now() };
    this.write();
  }
  restore(route, root) {
    const snapshot = this.state[this.key(route)]; if (!snapshot || !root) return;
    root.scrollTop = Math.max(0, Number(snapshot.scrollTop || 0));
    if (snapshot.focusKey) {
      const escaped = globalThis.CSS?.escape ? CSS.escape(snapshot.focusKey) : snapshot.focusKey.replace(/["\\]/g, '\\$&');
      const target = root.querySelector(`[data-focus-key="${escaped}"]`) || root.querySelector(`[name="${escaped}"]`);
      target?.focus?.({ preventScroll: true });
    }
  }
  read() { try { const value = JSON.parse(this.storage?.getItem(STORAGE_KEY) || '{}'); return value && typeof value === 'object' ? value : {}; } catch { return {}; } }
  write() { try { const entries = Object.entries(this.state).sort((a,b)=>(b[1]?.at||0)-(a[1]?.at||0)).slice(0,30); this.storage?.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(entries))); } catch {} }
}
